// Individual Report Template Builder Main State

import { IndReportsTemplateModel } from './indTemplate.model';

export const indReportsFeatureKey = 'ind-report-template';

export interface IndTemplateState {
  template: IndReportsTemplateModel | null;
  selectedSurveyOid: number;
  loading: boolean;
  error: string | null;
}

export const initialTemplateState: IndTemplateState = {
  template: null,
  selectedSurveyOid: 0,
  loading: false,
  error: null,
};
